import { useEffect, useState } from "react";
import { Alert, Row, Col, Form, Label, Button } from "reactstrap";
import { Link, Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import Loader from "../../components/Loader";
import { useAuth } from "../../context/AuthContext";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("E-mail inválido")
    .required("Por favor, insira o e-mail."),
  password: yup.string().required("Por favor, insira a senha."),
});

interface LoginForm {
  email: string;
  password: string;
}

const Login = () => {
  const navigate = useNavigate();
  const { login, loading, user } = useAuth();
  const [authError, setAuthError] = useState("");


  useEffect(() => {
    if (loading) return;
    if (!user) return;

    // 🚨 DESVIO META
    if (!user.isFaceCodeAuth || !user.isFaceTokenAuth) {
      navigate("/auth-facebook", { replace: true });
      return;
    }

    // ✅ LOGIN OK → DASHBOARD
    navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);


  // ⭐ react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  // ⭐ SUBMIT REAL
  const onSubmit = async (data: LoginForm) => {
    setAuthError("");
    setAuthError("");

    try {
      await login({
        mail: data.email,
        password: data.password,
      });

      // sucesso → redireciona
    } catch (err) {
      setAuthError("E-mail ou senha inválidos.");
    }
  };

  return (
    <NonAuthLayoutWrapper>
      <Row className="justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5} className="col-xxl-4">
          <div className="py-md-5 py-4">
            <AuthHeader
              title="Seja bem-vindo novamente!"
              subtitle="Faça login para continuar no ZConnect."
            />

            {loading && <Loader />}

            {authError && <Alert color="danger">{authError}</Alert>}

            <Form onSubmit={handleSubmit(onSubmit)} className="position-relative">
              {/* Email */}
              <div className="mb-3">
                <Label className="form-label">E-mail</Label>

                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="Informe seu e-mail"
                  {...register("email")}
                />

                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>

              {/* Password */}
              <div className="mb-3">
                <Label className="form-label">Senha</Label>

                <input
                  type="password"
                  className={`form-control ${errors.password ? "is-invalid" : ""}`}
                  placeholder="Sua senha"
                  {...register("password")}
                />

                {errors.password && (
                  <div className="invalid-feedback">{errors.password.message}</div>
                )}
              </div>

              <div className="form-check form-check-info font-size-16 mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="remember-check"
                />
                <Label
                  className="form-check-label font-size-14"
                  htmlFor="remember-check"
                >
                  Lembrar de mim
                </Label>
              </div>

              <div className="text-center mt-4">
                <Button color="primary" className="w-100" type="submit" disabled={loading}>
                  {loading ? "Entrando..." : "Entrar"}
                </Button>
              </div>


              {/* )} */}
              <div className="mt-5 text-center text-muted">
                <p>
                  Não tem uma conta?{" "}
                  <Link to="/auth-register" className="fw-medium text-decoration-underline">
                    Cadastre-se
                  </Link>
                </p>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default Login;
